<template>
    <div class="wrapper-dialog">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: 'WrapperDialog'
    }
</script>

<style lang="stylus">
    .wrapper-dialog
        text-align center
        .dialog-erro
            .dialog-title
                color: #cc1313
                font-weight bold
                font-size 16px
        .dialog-sucesso
            .dialog-title
                color #7aa329
                font-weight bold
                font-size 16px
        .dialog-text
            font-size 13px
</style>